const DiscordRedirect = () => {
    window.location.href = "https://discord.gg/xsCmYnBJUm"
}

export default DiscordRedirect